import { View } from '@react-pdf/renderer';
import React from 'react';
import pdfStyles, { borderStyle } from '../pdfDocument/pdfStyles';

type Variant = 'four' | 'double';

type Props = { variant?: Variant };

const BadgePageDivider = ({ variant = 'four' }: Props) => {
  if (variant === 'double') {
    return (
      <View style={{ position: 'absolute', width: '100%', height: '100%' }}>
        <View
          style={[pdfStyles.halfFlex, { borderRight: borderStyle, borderBottom: borderStyle }, pdfStyles.dividerHeight]}
        ></View>
        <View style={[pdfStyles.halfFlex, { borderBottom: borderStyle }, pdfStyles.dividerHeight]}></View>
      </View>
    );
  }
  return (
    <View style={pdfStyles.defaultDividerContainer}>
      <View style={[pdfStyles.halfFlex, { borderRight: borderStyle, borderBottom: borderStyle }, pdfStyles.dividerHeight]}></View>
      <View style={[pdfStyles.halfFlex, { borderBottom: borderStyle }, pdfStyles.dividerHeight]}></View>
      <View style={[pdfStyles.halfFlex, { borderRight: borderStyle }, pdfStyles.dividerHeight]}></View>
      <View style={[pdfStyles.halfFlex, pdfStyles.dividerHeight]}></View>
    </View>
  );
};

export default BadgePageDivider;
